import React from "react";

const RowSelector = ({
  selectedValue,
  onChange,
  onDelete,
  rowId,
  rowIndex,
  openModal,
  widgets,
  layoutOptions,
}) => {
  const option =
    layoutOptions.find((opt) => opt.value === selectedValue) ||
    layoutOptions[0];

  return (
    <div className="row-card">
      <div className="row-card-main">
        <div className="row-header">Row {rowIndex + 1}</div>
        <select
          className="form-control-row"
          value={selectedValue}
          onChange={(e) => onChange(e.target.value)}
        >
          {layoutOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.text}
            </option>
          ))}
        </select>
        {option.image && (
          <img
            src={option.image}
            alt={option.text}
            style={{
              width: "20%",
              height: "40px",
              margin: "8px 0",
              borderRadius: "unset",
            }}
          />
        )}
        <div className="row-card-config-buttons">
          {Array.from({ length: option.buttons }).map((_, idx) => (
            <button
              className="configure-btn"
              onClick={() => openModal(idx)}
              key={idx}
              type="button"
            >
              Configure
            </button>
          ))}
        </div>
      </div>
      <button
        className="icon-btn"
        onClick={onDelete}
        title="Delete row"
        type="button"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="red"
          viewBox="0 0 16 16"
        >
          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
        </svg>
      </button>
    </div>
  );
};

export default RowSelector;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/RowSelector.js